import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './IncentiveEditScreen';
import IncentiveEdit from './IncentiveEditScreen';
import { StoreState } from 'src/store/reducers';
import { getIncentive } from 'src/store/actions/incentive-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        incentive: state.incentives.current,
        inProgress: state.incentives.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getIncentive(id)),
    };
}

const IncentiveEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(IncentiveEdit);

export default IncentiveEditScreen;
